import { render, staticRenderFns } from "./BankAccountingItemsRelationSettings.vue?vue&type=template&id=026c0aca&scoped=true&"
import script from "./BankAccountingItemsRelationSettings.vue?vue&type=script&lang=js&"
export * from "./BankAccountingItemsRelationSettings.vue?vue&type=script&lang=js&"
import style0 from "./BankAccountingItemsRelationSettings.vue?vue&type=style&index=0&id=026c0aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "026c0aca",
  null
  
)

export default component.exports